export default __webpack_public_path__ + "static/media/dsv-brt-it.cacb0215.svg";